"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _constants = require("./constants");
var _Tabs2 = _interopRequireDefault(require("./Tabs.style"));
var _TabHeader = _interopRequireDefault(require("./header/TabHeader"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tabs = /*#__PURE__*/function (_React$Component) {
  function Tabs(props) {
    var _this;
    _classCallCheck(this, Tabs);
    _this = _callSuper(this, Tabs, [props]);
    _defineProperty(_this, "handleTabClick", function (tabIndex, allowNavigation) {
      var _this$props = _this.props,
        controlledTabNavigation = _this$props.controlledTabNavigation,
        onTabChange = _this$props.onTabChange;
      if (!controlledTabNavigation) {
        _this.setState({
          activeTabIndex: tabIndex
        });
      }
      if (onTabChange && allowNavigation) onTabChange(tabIndex, _this.state.activeTabIndex);
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_this, "moveToNextTab", function () {
      var _this$state = _this.state,
        activeTabIndex = _this$state.activeTabIndex,
        noOfTabs = _this$state.noOfTabs;
      var onTabChange = _this.props.onTabChange;
      if (activeTabIndex < noOfTabs - 1) {
        var newTabIndex = activeTabIndex + 1;
        _this.setState({
          activeTabIndex: newTabIndex
        });
        if (onTabChange) onTabChange(newTabIndex, activeTabIndex);
      }
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_this, "moveToPreviousTab", function () {
      var activeTabIndex = _this.state.activeTabIndex;
      var onTabChange = _this.props.onTabChange;
      if (activeTabIndex !== 0) {
        var newTabIndex = activeTabIndex - 1;
        _this.setState({
          activeTabIndex: newTabIndex
        });
        if (onTabChange) onTabChange(newTabIndex, activeTabIndex);
      }
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_this, "moveToSelectedTab", function (index) {
      _this.setState({
        activeTabIndex: index
      });
    });
    _defineProperty(_this, "renderContent", function () {
      var children = _this.props.children.filter(function (item) {
        return item;
      }); // remove falsy values
      var activeTabIndex = _this.state.activeTabIndex;
      if (children[activeTabIndex]) {
        return children[activeTabIndex].props.children;
      }
      return null;
    });
    var _noOfTabs = props.children ? props.children.length : 0;
    _this.state = {
      activeTabIndex: props.defaultActiveTabIndex,
      noOfTabs: _noOfTabs
    };
    return _this;
  }
  _inherits(Tabs, _React$Component);
  return _createClass(Tabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        controlledTabNavigation = _this$props2.controlledTabNavigation,
        defaultActiveTabIndex = _this$props2.defaultActiveTabIndex;
      var activeTabIndex = this.state.activeTabIndex;
      if (controlledTabNavigation && prevProps.defaultActiveTabIndex !== defaultActiveTabIndex && activeTabIndex !== defaultActiveTabIndex) {
        this.setState({
          activeTabIndex: defaultActiveTabIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        alignment = _this$props3.alignment,
        noMargins = _this$props3.noMargins,
        children = _this$props3.children,
        view = _this$props3.view,
        className = _this$props3.className,
        controlledTabNavigation = _this$props3.controlledTabNavigation,
        isWizzard = _this$props3.isWizzard,
        headerExtra = _this$props3.headerExtra;
      return /*#__PURE__*/_react["default"].createElement(_Tabs2["default"], {
        className: className,
        hasExtra: !(0, _utils.isBlank)(headerExtra)
      }, children && /*#__PURE__*/_react["default"].createElement(_TabHeader["default"], {
        view: view,
        alignment: alignment,
        noMargins: noMargins,
        isWizzard: isWizzard,
        controllable: controlledTabNavigation
      }, _react["default"].Children.map(_react["default"].Children.toArray(children), function (child, index) {
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          onClick: _this2.handleTabClick,
          tabIndex: index,
          isActive: index === _this2.state.activeTabIndex,
          isWizzard: isWizzard,
          controlledTabNavigation: controlledTabNavigation,
          view: view
        });
      })), headerExtra && /*#__PURE__*/_react["default"].createElement("div", {
        className: "header-extra"
      }, headerExtra), children && /*#__PURE__*/_react["default"].createElement("div", {
        className: "tabs-active-content"
      }, this.renderContent()));
    }
  }]);
}(_react["default"].Component);
Tabs.propTypes = {
  view: _propTypes["default"].oneOf(R.values(_constants.VIEW_TYPE)),
  defaultActiveTabIndex: _propTypes["default"].number,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  headerExtra: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  controlledTabNavigation: _propTypes["default"].bool,
  alignment: _propTypes["default"].string,
  noMargins: _propTypes["default"].bool,
  isWizzard: _propTypes["default"].bool,
  onTabChange: _propTypes["default"].func,
  className: _propTypes["default"].string
};
Tabs.defaultProps = {
  onTabChange: function onTabChange() {},
  defaultActiveTabIndex: 0,
  controlledTabNavigation: false,
  alignment: _constants.ALIGNMENT_MAP.center,
  noMargins: false,
  children: null,
  headerExtra: null,
  isWizzard: false,
  className: 'Tabs-container',
  view: _constants.VIEW_TYPE["default"]
};
var _default = exports["default"] = Tabs;